import React, { useState } from 'react';
import { Box, StackView } from '@telus-uds/components-web';

// Box migrated to UDS

import { initialFieldData } from '../../utils'; 

import DefectWebform from './defectWebform';
import DefectCategory from './defectCatagory';
import DefectPriority from './defectPriority';
import DefectIssueSummary from './defectIssueSummary';
import DefectErrorMessage from './defectErrorMessage';
import DefectStepsToReplicate from './defectStepsToReplicate';
import SubmitButton from './button';
import DefectAttachment from './defectAttachment';
import DefectWebformOrderId from './DefectWebformOrderId'

const Form = () => {
  const [fieldData, setFieldData] = useState(initialFieldData);
  const [formErrors, setFormErrors] = useState({});

  return (
    <>
      <Box tag="section" top={4}>
        <StackView space={4}>
          <DefectWebform
            fieldData={fieldData}
            setFieldData={setFieldData}
            formErrors={formErrors}
            setFormErrors={setFormErrors}
          />
          <DefectCategory
            fieldData={fieldData}
            setFieldData={setFieldData}
            formErrors={formErrors}
            setFormErrors={setFormErrors}
          />
          <DefectPriority
            fieldData={fieldData}
            setFieldData={setFieldData}
            formErrors={formErrors}
            setFormErrors={setFormErrors}
          />
          <DefectIssueSummary
            fieldData={fieldData}
            setFieldData={setFieldData}
            formErrors={formErrors}
            setFormErrors={setFormErrors}
          />
          <DefectWebformOrderId
            fieldData={fieldData}
            setFieldData={setFieldData}
            formErrors={formErrors}
            setFormErrors={setFormErrors}
          />
          <DefectErrorMessage
            fieldData={fieldData}
            setFieldData={setFieldData}
            formErrors={formErrors}
            setFormErrors={setFormErrors}
          />
          <DefectStepsToReplicate
            fieldData={fieldData}
            setFieldData={setFieldData}
            formErrors={formErrors}
            setFormErrors={setFormErrors}
          />
          <DefectAttachment fieldData={fieldData} setFieldData={setFieldData} />
          <SubmitButton
            fieldData={fieldData}
            setFieldData={setFieldData}
            formErrors={formErrors}
            setFormErrors={setFormErrors}
          />
        </StackView>
      </Box>
    </>
  );
};

export default Form;
